export const STATUS = {
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
  ARCHIVED: 'Archived',
}

/** Mirrors `AccountDeactivationStatus` in crm-common; an account with no run in flight carries none. */
export const ACCOUNT_DEACTIVATION_STATUS = {
  SCHEDULED: 'SCHEDULED',
  IN_PROGRESS: 'IN_PROGRESS',
  FAILED: 'FAILED',
} as const

export type AccountDeactivationStatus = typeof ACCOUNT_DEACTIVATION_STATUS[keyof typeof ACCOUNT_DEACTIVATION_STATUS]

/**
 * A run holds the account from the moment it is scheduled until it finishes, and the server
 * rejects a second request for as long as it does. `FAILED` released the account, so it is not pending.
 */
export const isDeactivationPending = (status?: string | null): boolean =>
  status === ACCOUNT_DEACTIVATION_STATUS.SCHEDULED || status === ACCOUNT_DEACTIVATION_STATUS.IN_PROGRESS

// Mirrors the server's WORK_ORDERS_REGENERATION_WINDOW: past it, the server treats the run as lost too.
export const REACTIVATION_WORK_ORDERS_WINDOW_MS = 3 * 60 * 60 * 1000

// The server sends its UTC wall clock with no offset, so a bare value has to be read as UTC.
export const isReactivationInProgress = (since?: string | null, now: number = Date.now()): boolean => {
  if (!since) return false
  const startedAt = Date.parse(/(Z|[+-]\d{2}:?\d{2})$/.test(since) ? since : `${since}Z`)
  return !Number.isNaN(startedAt) && now - startedAt < REACTIVATION_WORK_ORDERS_WINDOW_MS
}
